import { useEffect } from "react";
import "./App.css";
import LandingPage from "./components/LandingPage";

function App() {
  useEffect(() => {
    const light = document.getElementById("light");

    const move = (e) => {
      if (light) {
        light.style.left = e.clientX + "px";
        light.style.top = e.clientY + "px";
      }

      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;

      document.body.style.setProperty("--x", x + "%");
      document.body.style.setProperty("--y", y + "%");
    };

    window.addEventListener("mousemove", move);

    return () => window.removeEventListener("mousemove", move);
  }, []);

  return (
    <div className="App">
      <LandingPage />
      <div className="glass-overlay"></div>
      <div className="moving-light" id="light"></div>
    </div>
  );
}

export default App;
